import { Component, OnDestroy, OnInit } from '@angular/core';
import {OrganisationPreferencesService} from '../../../_services/organisation/organisation-preferences.service';
import {FormGroup, FormControl} from '@angular/forms';
import {OrganisationPreferencesModel} from '../../../_models/organisation/organisation-preferences.model';
import {MessageService} from 'primeng/api';

@Component({
  selector: 'acabim-admin-organisation-preferences',
  templateUrl: './organisation-preferences.component.html',
  styleUrls: ['./organisation-preferences.component.scss']
})
export class OrganisationPreferencesComponent implements OnInit, OnDestroy {

  preferences: OrganisationPreferencesModel | null = null;
  isLoading = false;

  preferencesForm: FormGroup = new FormGroup({
    runActionTasks: new FormControl(),
    runGenerateAssetsTask: new FormControl(),
    runImportProjectLtmsTask: new FormControl(),
    brandingBanner: new FormControl(),
    brandingBannerColour: new FormControl(),
    brandingTextColour: new FormControl(),
  });

  constructor(
      private readonly preferencesService: OrganisationPreferencesService,
      private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.getPreferences();
  }

  getPreferences(): void {
    this.isLoading = true;
    this.preferencesService.getPreferences().subscribe(data => {
      this.preferences = data;
      this.isLoading = false;
      if (data && this.preferencesForm) {
        this.preferencesForm.get('runActionTasks')?.setValue(data.run_action_tasks);
        this.preferencesForm.get('runGenerateAssetsTask')?.setValue(data.run_generate_assets_task);
        this.preferencesForm.get('runImportProjectLtmsTask')?.setValue(data.run_import_project_ltms_task);
        this.preferencesForm.get('brandingBanner')?.setValue(data.branding_banner);
        this.preferencesForm.get('brandingBannerColour')?.setValue(data.branding_banner_colour);
        this.preferencesForm.get('brandingTextColour')?.setValue(data.branding_text_colour);
        this.watch();
      }
    });
  }

  watch(): void {
    if (this.preferencesForm && this.preferences) {
      this.preferencesForm.get('runActionTasks')?.valueChanges.subscribe(val => {
        if (val !== this.preferences?.run_action_tasks) {
          this.handlePreferenceUpdate('run_action_tasks', val);
        }
      });
      this.preferencesForm.get('runGenerateAssetsTask')?.valueChanges.subscribe(val => {
        if (val !== this.preferences?.run_generate_assets_task) {
          this.handlePreferenceUpdate('run_generate_assets_task', val);
        }
      });
      this.preferencesForm.get('runImportProjectLtmsTask')?.valueChanges.subscribe(val => {
        if (val !== this.preferences?.run_import_project_ltms_task) {
          this.handlePreferenceUpdate('run_import_project_ltms_task', val);
        }
      });
      this.preferencesForm.get('brandingBanner')?.valueChanges.subscribe(val => {
        if (val !== this.preferences?.branding_banner) {
          this.handlePreferenceUpdate('branding_banner', val);
        }
      });
    }
  }

  handlePreferenceUpdate(type: string, value: boolean) {
    this.preferencesService.updatePreference(type, value).subscribe(res => {
      console.dir(res);
      this.messageService.clear('organisationPreferences');
      this.messageService.add({severity: 'success', summary: 'Preference update', detail: 'Successfully updated preference', key: 'organisationPreferences'});
    });
  }

  updateBrandingBackgroundColour() {
    const colour = this.preferencesForm.get('brandingBannerColour')?.value;
    if (colour !== this.preferences?.branding_banner_colour) {
      this.handlePreferenceUpdate('branding_banner_colour', colour);
    }
  }

  updateBrandingTextColour() {
    const colour = this.preferencesForm.get('brandingTextColour')?.value;
    if (colour !== this.preferences?.branding_text_colour) {
      this.handlePreferenceUpdate('branding_text_colour', colour);
    }
  }
  ngOnDestroy(): void {

  }

}
